import { createReducer } from '../../utilities';
import {
    REQUEST_FETCH_STATS_LEAGUES_BY_STATUS,
    SUCCESS_FETCH_STATS_LEAGUES_BY_STATUS,
    FAIL_FETCH_STATS_LEAGUES_BY_STATUS,
} from "../../../actions/entities/statistics/leagues";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_LEAGUES_BY_STATUS]: requestFetch,
    [SUCCESS_FETCH_STATS_LEAGUES_BY_STATUS]: successFetch,
    [FAIL_FETCH_STATS_LEAGUES_BY_STATUS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/leaguesByStatus.js